<template>
  <div class="editPage" v-loading="subLoading">
    <qx-card :title="'GPS信息'">
      <BaseForm ref="baseForm" />
      <GpsForm ref="gpsForm" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import GpsForm from './gps';
import SubBtnBox from 'components/subBtnBox';
import {
  getVehicleStandingBookInfo,
  doSaveOrUpdateVehicleStandingBookInfo,
} from 'api/car';
import {
  getEnumList,
} from 'api';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    GpsForm,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/car/maintain/gps/edit',
      formComponents: [
        'baseForm',
        'gpsForm',
      ],

      subLoading: false,
      // 需要对比的参数
      compareParams: {
        plateNumber: '',
        suitType: '',
        picList: [],
      },
    };
  },
  computed: {
    detailParams () {
      return {
        id: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: getVehicleStandingBookInfo,
    editApi: doSaveOrUpdateVehicleStandingBookInfo,

    // 处理对比参数
    adjustCompareParams (compareParams) {
      if (compareParams.picList.length) {
        compareParams.picFileIds = (compareParams.picList.map((item) => item.fileId)).join(',');
      } else {
        compareParams.picFileIds = '';
      }
    },
    getLog () {
      if (this.$route.query.type === 'detail') {
        this.$refs.logTable.saveSearchBoxData({
          busiId: this.$route.query.id,
          busiCode: '3000013',
          type: 1,
        });
      }
    },
  },
  async mounted () {
    const enumsList = await getEnumList({
      codeType: 'GPS_SUIT_TYPE',
    });
    this.$refs.gpsForm.setOptions(enumsList[0]);
    this.getData();
  },
};
</script>

<style>
</style>
